import { render, staticRenderFns } from "./NIHSSVision.vue?vue&type=template&id=1abcd5ca&scoped=true&"
import script from "./NIHSSVision.vue?vue&type=script&lang=ts&"
export * from "./NIHSSVision.vue?vue&type=script&lang=ts&"
import style0 from "./NIHSSVision.vue?vue&type=style&index=0&id=1abcd5ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abcd5ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abcd5ca')) {
      api.createRecord('1abcd5ca', component.options)
    } else {
      api.reload('1abcd5ca', component.options)
    }
    module.hot.accept("./NIHSSVision.vue?vue&type=template&id=1abcd5ca&scoped=true&", function () {
      api.rerender('1abcd5ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standalone/NIHSSVision.vue"
export default component.exports